export const version = '2.9.13';
//# sourceMappingURL=version.js.map